import { UserRelationRoleEnum, SingleUser, DossierRelationResponse } from '../api/types';
import { User } from './User';
import { GetRollTextProps, Dossier } from './Dossier';

export interface DossierMemberInterface {
  memberId: number;
  role: UserRelationRoleEnum;
  user: SingleUser;
}

export class DossierMember implements DossierMemberInterface {
  memberId: number;
  role: UserRelationRoleEnum;
  user: User;

  constructor({ memberId, role, user }: DossierMemberInterface) {
    this.memberId = memberId;
    this.role = role;
    this.user = new User(user);
  }

  static fromRequest(response: DossierRelationResponse[]): DossierMember[] {
    return response.map(relation => (
      new DossierMember({
        memberId: relation.id,
        role: relation.relationRole,
        user: relation.user,
      })
    ));
  }

  match(member: DossierMember): boolean {
    return member.memberId === this.memberId;
  }

  getRoleText(options?: GetRollTextProps): string {
    return Dossier.getRoleText(this.role, options);
  }
}
